/* indicators-container.tsx generated by @compiled/babel-plugin v0.38.1 */
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showClearIndicator"];
import "./indicators-container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { components } from '@atlaskit/select';
var styles = {
  calendarButtonInclusionStyles: "_ahbqxy5q",
  calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var IndicatorsContainer = function IndicatorsContainer(_ref) {
  var showClearIndicator = _ref.showClearIndicator,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: ax([showClearIndicator ? styles.calendarButtonInclusionStyles : styles.calendarButtonOnlyInclusionStyles])
  }, /*#__PURE__*/React.createElement(components.IndicatorsContainer, rest));
};